import React from 'react';
import './OrderListPrimeReact.css';
import GeneralUtils from "../../shared/utils/GeneralUtils";
import WebMenuMemberService from "../../shared/service/WebMenuMemberService";
import {Button} from "primereact/button";
import {Button as ButtonReactStrap, ButtonGroup, Col, Row} from "reactstrap";
import {OrderCheckOut} from "../../shared/layaout/sigma/OrderCheckOut";
import ItemDetailsCheckOut from "./ItemDetailsCheckOut";
import BasketService from "../../shared/service/BasketService";
import {PAGE_MODE, WEB_IMAGE_SERVER_URL} from "../../shared/utils/Constants";
import {ProgressBar} from 'primereact/progressbar';
import {AppFooterMemberMobile} from "../../shared/layaout/sigma/AppFooterMemberMobile";
import {MemberCookieConsentBanner} from "../../shared/layaout/sigma/MemberCookieConsentBanner";
import 'react-tabs-scrollable/dist/rts.css'
import MemberUserSecurityService from "../../shared/service/MemberUserSecurityService";
import {InputText} from 'primereact/inputtext';
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import {Chip} from "@material-ui/core";
import {Card} from 'primereact/card';
import {OrderList} from 'primereact/orderlist';
import MarketPlace from "./MarketPlace";
import MerchantBranchService from "../../shared/service/MerchantBranchService";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import LicenseService from "../../shared/service/LicenseService";
import PageSettingsService from "../../shared/service/PageSettingsService";
import Dialog from "../../shared/component/dialog/Dialog";
import {Dropdown} from "primereact/components/dropdown/Dropdown";
import {toast} from "react-toastify";
import AddressService from "../../shared/service/AddressService";
import MemberUserAddressService from "../../shared/service/MemberUserAddressService";

const defaultAddressInfo = {
    addressText: '',
    contactPhone: '',
    storeOpenOrCloseMessageText: '',
    onlineOrderingMessageText: '',
    onlineOrderingWindowHintText: '',
    tradingName: '',
    menuBorderColor: null,
    menuDisplayTemplate: 'Template1'
};


export default class DashboardMember extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            shortcuts: [],
            products: [],
            crumbItems: [],
            displayDialog: false,
            hasDeliveryOrderType: false,
            servicableThisPostCode: false,
            loading: false,
            deliveryTypesList: [],
            addressInfo: defaultAddressInfo,
            postCode: "",
            postCodeTemp: "",
            filteredAddresses: [],
            isSetMenu: true,
            showItems: true,
            index: 0,
            searchText: "",
            orderType: null,
            indexTemp: 0,
            selectedMenu: null,
            offset: 0,
            limit: 40,
            allDataLoaded: false,
            brokenImageMap: {},
            subMenuChips: [],
        };
        this.productItem = this.productItem.bind(this);
        this.webMenuMemberService = new WebMenuMemberService();
        this.basketService = new BasketService();
        this.memberUserSecurityService = new MemberUserSecurityService();
        this.merchantBranchService = new MerchantBranchService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
        this.licenseService = new LicenseService();
        this.pageSettingsService = new PageSettingsService();
        this.addressService = new AddressService();
        this.memberUserAddressService = new MemberUserAddressService();
        /** Artan nesil; geciken web menü istekleri (kök shortcuts / ürün listesi) alt menüye geçildikten sonra state'i bozmasın */
        this._menuSyncEpoch = 0;
        /** İlk açılışta componentDidMount + componentDidUpdate çift yükleme yapmasın */
        this._memberStoreHomeInitialized = false;
        /** loadMore: state.loading asenkron olduğundan aynı offset ile birden fazla sayfa isteği gitmesin */
        this._memberMenuLoadMoreLock = false;
        /** Menü scroll sırasında + ghost click / gecikmeli dialog açılışı */
        this._lastWindowScrollAt = 0;
        this._productOpenToken = 0;
        this._productOpenGesture = null;
        /** Ürün dialog açıkken web menü arka plan scroll kilidi */
        this._bodyScrollLocked = false;
        this._bodyScrollY = 0;
        this.handlePopState = this.handlePopState.bind(this);
        this.preventBackgroundTouchScroll = this.preventBackgroundTouchScroll.bind(this);
        this.onLockedWindowScroll = this.onLockedWindowScroll.bind(this);
        this.onDialogFocusIn = this.onDialogFocusIn.bind(this);
        this.onDialogPointerDown = this.onDialogPointerDown.bind(this);
    }

    bumpMemberMenuContext = () => {
        this._menuSyncEpoch++;
    };

    initializeMemberStoreHome = (merchantBranchId) => {
        if (this._memberStoreHomeInitialized || !this.isValidMerchantBranchId(merchantBranchId)) {
            return;
        }
        this._memberStoreHomeInitialized = true;
        this.getDeliveryTypes();
        this.bumpMemberMenuContext();
        this.getLogo(merchantBranchId);
        this.getBasketInfo();
        this.setState({
            selectedMenu: null,
            offset: 0,
            allDataLoaded: false
        }, () => {
            this.getWebMenuList(() => this.getProductsForHomeParent());
        });
    };

    /**
     * Ürün / kategori alanının React içinde sıfırlanması: OrderList zaman zaman aynı parent altında
     * eski satırları tutabiliyor; menü bağlamı değişince key ile bileşeni yeniden mount ederiz.
     * forProductList: arama açıksa metni da key'e alırız.
     */
    getMemberMenuFrameKey(forProductList = false) {
        const sm = this.state.selectedMenu == null ? '-1' : String(this.state.selectedMenu);
        const trail = this.state.crumbItems.length
            ? this.state.crumbItems.map(c => String(c.id)).join('-')
            : 'root';
        let k = `nav-${sm}-${trail}`;
        if (forProductList && this.state.searchText.length > 3) {
            k += `-q-${encodeURIComponent(this.state.searchText.slice(0, 128))}`;
        }
        return k;
    }

    componentDidUpdate(prevProps, prevState) {
        let branchName = GeneralUtils.getDomainName();
        if (!GeneralUtils.isNullOrEmpty(branchName)) {
            if (prevState.branchName == undefined) {
                this.merchantBranchService.getBranchIdByDomainName(branchName).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && response != 0) {
                        localStorage.setItem("merchantBranchId", response);
                        this.setState({
                            branchName: branchName,
                            selectedMenu: null,
                            offset: 0,
                            allDataLoaded: false
                        });
                        this.initializeMemberStoreHome(response);
                    } else {
                        window.location.href = '/'
                        this.setState({
                            branchName: null,
                        });
                    }

                });

            } else if (prevState.branchName !== branchName) {
                this._memberStoreHomeInitialized = false;
                this.merchantBranchService.getBranchIdByDomainName(branchName).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && response != 0) {
                        localStorage.setItem("merchantBranchId", response);
                        this.setState({
                            branchName: branchName,
                            crumbItems: [],
                            shortcuts: [],
                            subMenuChips: [],
                            products: [],
                            selectedCardId: null,
                            selectedMenu: null,
                            offset: 0,
                            allDataLoaded: false
                        });
                        this.initializeMemberStoreHome(response);
                    } else {
                        window.location.href = '/'
                        localStorage.setItem("merchantBranchId", -1);
                        this.getLogo(-1)
                    }
                });
            }
        }

        if (prevState.displayDialog !== this.state.displayDialog) {
            this.syncBodyScrollLock(this.state.displayDialog);
        }
    }


    componentDidMount = () => {
        window.addEventListener('popstate', this.handlePopState);

        refreshToken(this.memberUserSecurityService);

        function refreshToken(service) {
            setInterval(function () {
                if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("userType")) && localStorage.getItem("userType") == "member") {

                    if (!GeneralUtils.isNullOrEmpty(GeneralUtils.getRefreshTokenFromCookie())) {
                        service.refreshToken().then(response => {
                            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                GeneralUtils.setJwtToCookie(response.accessToken, response.refreshToken, response.expireDate).then(() => {});
                            }
                        });
                    }
                }

            }, 1000 * 60 * 60 * 24);
        }


        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("displayAddressString")) && localStorage.getItem("displayAddressString") != "undefined") {
            let postCode = localStorage.getItem("displayAddressString");
            this.setState({
                postCode: postCode, servicableThisPostCode: true, postCodeTemp: localStorage.getItem("postCode")
            });

        } else {
            if (GeneralUtils.isAuthenticated()) {
                this.getUserCurrentAddress()
            }


        }

        window.addEventListener('scroll', this.handleScroll);
        const merchantBranchId = localStorage.getItem("merchantBranchId");
        const domainBranch = GeneralUtils.getDomainName();
        // Subdomain store: branch id + menü yüklemesi componentDidUpdate'te bir kez yapılır.
        if (this.isValidMerchantBranchId(merchantBranchId) && GeneralUtils.isNullOrEmpty(domainBranch)) {
            this.initializeMemberStoreHome(merchantBranchId);
        }


    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('popstate', this.handlePopState);
        this.syncBodyScrollLock(false);
    }

    /**
     * Popup açıkken web menü arka planı kaymasın.
     * position:fixed kullanma — bottom sheet / portal dialog konumunu bozuyor.
     */
    syncBodyScrollLock = (locked) => {
        if (typeof document === 'undefined' || !document.body) {
            return;
        }
        const html = document.documentElement;
        if (locked) {
            if (this._bodyScrollLocked) {
                return;
            }
            this._bodyScrollY = window.scrollY || window.pageYOffset || 0;
            this._bodyScrollLocked = true;
            html.classList.add('member-dialog-scroll-lock');
            document.body.classList.add('member-dialog-scroll-lock');
            html.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            document.addEventListener('touchmove', this.preventBackgroundTouchScroll, {passive: false});
            window.addEventListener('scroll', this.onLockedWindowScroll, {passive: false});
            document.addEventListener('focusin', this.onDialogFocusIn, true);
            document.addEventListener('pointerdown', this.onDialogPointerDown, true);
            return;
        }
        if (!this._bodyScrollLocked) {
            return;
        }
        this._bodyScrollLocked = false;
        this._dialogScrollFreeze = null;
        document.removeEventListener('touchmove', this.preventBackgroundTouchScroll, {passive: false});
        window.removeEventListener('scroll', this.onLockedWindowScroll, {passive: false});
        document.removeEventListener('focusin', this.onDialogFocusIn, true);
        document.removeEventListener('pointerdown', this.onDialogPointerDown, true);
        html.classList.remove('member-dialog-scroll-lock');
        document.body.classList.remove('member-dialog-scroll-lock');
        html.style.overflow = '';
        document.body.style.overflow = '';
        const y = this._bodyScrollY || 0;
        window.requestAnimationFrame(() => {
            window.scrollTo(0, y);
        });
    };

    onLockedWindowScroll() {
        if (!this._bodyScrollLocked) {
            return;
        }
        const y = this._bodyScrollY || 0;
        if ((window.scrollY || window.pageYOffset || 0) !== y) {
            window.scrollTo(0, y);
        }
    };

    onDialogPointerDown(e) {
        if (!this._bodyScrollLocked) {
            return;
        }
        const scrollEl = e.target && e.target.closest
            ? e.target.closest('.item-details-dialog__scroll')
            : null;
        const contentEl = e.target && e.target.closest
            ? e.target.closest('.item-details-dialog-root .p-dialog-content')
            : null;
        this._dialogScrollFreeze = {
            scrollEl,
            scrollTop: scrollEl ? scrollEl.scrollTop : 0,
            contentEl,
            contentTop: contentEl ? contentEl.scrollTop : 0,
            winY: this._bodyScrollY || 0
        };
    }

    onDialogFocusIn(e) {
        if (!this._bodyScrollLocked) {
            return;
        }
        const freeze = this._dialogScrollFreeze;
        const restore = () => {
            window.scrollTo(0, (freeze && freeze.winY != null) ? freeze.winY : (this._bodyScrollY || 0));
            if (freeze && freeze.contentEl) {
                freeze.contentEl.scrollTop = freeze.contentTop || 0;
            }
            if (freeze && freeze.scrollEl) {
                freeze.scrollEl.scrollTop = freeze.scrollTop;
            }
            const content = e.target && e.target.closest
                ? e.target.closest('.item-details-dialog-root .p-dialog-content')
                : null;
            if (content && (!freeze || !freeze.contentEl)) {
                content.scrollTop = 0;
            }
        };
        window.requestAnimationFrame(restore);
        window.setTimeout(restore, 0);
    }

    isTouchScrollAllowedTarget = (target) => {
        let el = target;
        while (el && el !== document.body) {
            if (el.classList && el.classList.contains('item-details-dialog__scroll')) {
                return true;
            }
            el = el.parentElement;
        }
        return false;
    };

    preventBackgroundTouchScroll(e) {
        if (!this._bodyScrollLocked) {
            return;
        }
        if (this.isTouchScrollAllowedTarget(e.target)) {
            return;
        }
        e.preventDefault();
    }

    getEventPoint = (e) => {
        if (!e) {
            return null;
        }
        if (typeof e.clientX === 'number' && typeof e.clientY === 'number') {
            return {x: e.clientX, y: e.clientY};
        }
        const touch = (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]);
        if (touch && typeof touch.clientX === 'number') {
            return {x: touch.clientX, y: touch.clientY};
        }
        return null;
    };

    onProductOpenPointerDown = (e) => {
        const point = this.getEventPoint(e);
        this._productOpenGesture = {
            x: point ? point.x : 0,
            y: point ? point.y : 0,
            scrollY: window.scrollY || window.pageYOffset || 0,
            moved: false
        };
    };

    onProductOpenPointerMove = (e) => {
        const gesture = this._productOpenGesture;
        if (!gesture || gesture.moved) {
            return;
        }
        const point = this.getEventPoint(e);
        if (!point) {
            return;
        }
        if (Math.abs(point.x - gesture.x) > 12 || Math.abs(point.y - gesture.y) > 12) {
            gesture.moved = true;
        }
    };

    onProductOpenPointerCancel = () => {
        if (this._productOpenGesture) {
            this._productOpenGesture.moved = true;
        }
    };

    shouldIgnoreProductOpenFromGesture = () => {
        const gesture = this._productOpenGesture;
        const scrollY = window.scrollY || window.pageYOffset || 0;
        if (gesture) {
            if (gesture.moved) {
                return true;
            }
            if (Math.abs(scrollY - gesture.scrollY) > 8) {
                return true;
            }
        }
        return (Date.now() - this._lastWindowScrollAt) < 320;
    };

    openProductDialogFromList = (isSetMenu, prepareItem) => {
        if (this.shouldIgnoreProductOpenFromGesture()) {
            return;
        }
        this.openProductDialog(isSetMenu, prepareItem);
    };

    isMemberStoreMenuActive = () => {
        return !GeneralUtils.isNullOrEmpty(this.state.branchName);
    };

    pushMemberMenuHistoryState = () => {
        window.history.pushState({memberMenu: true}, document.title, window.location.href);
    };

    openProductDialog = (isSetMenu, prepareItem) => {
        this.setState({displayDialog: true, isSetMenu}, () => {
            if (typeof prepareItem === 'function') {
                this.runItemDetailsPrepare(prepareItem);
            }
            this.pushMemberMenuHistoryState();
        });
    };

    runItemDetailsPrepare = (prepareItem) => {
        if (this.itemsDetail) {
            prepareItem();
            return;
        }
        window.requestAnimationFrame(() => {
            if (this.itemsDetail) {
                prepareItem();
            }
        });
    };

    crumbToMenuItem(crumb) {
        return {
            name: crumb.label,
            id: crumb.id,
            lastShortcuts: crumb.lastShortcuts
        };
    }

    /** Breadcrumb / geri / üst menü geçişlerinde önceki sayfanın scroll'unu taşıma. */
    scrollMemberMenuToTop = () => {
        const go = () => {
            window.scrollTo(0, 0);
            if (document.documentElement) {
                document.documentElement.scrollTop = 0;
            }
            if (document.body) {
                document.body.scrollTop = 0;
            }
            this._bodyScrollY = 0;
        };
        go();
        window.requestAnimationFrame(go);
    };

    navigateToMemberMenuHome = () => {
        this.scrollMemberMenuToTop();
        this.bumpMemberMenuContext();
        this.setState({
            crumbItems: [], products: [],
            shortcuts: [],
            subMenuChips: [],
            selectedCardId: null,
            offset: 0,
            selectedMenu: null,
            allDataLoaded: false
        }, () => {
            this.scrollMemberMenuToTop();
            this.getWebMenuList(() => this.getProductsForHomeParent());
        });
    };

    /**
     * Alt menüdeyken bir üst breadcrumb seviyesine döner.
     * @returns {boolean|null} true = ana menüye çıkıldı, false = bir üst alt menü, null = işlem yok
     */
    handleMemberMenuBack = () => {
        const {crumbItems} = this.state;
        if (!crumbItems || crumbItems.length === 0) {
            return null;
        }
        if (crumbItems.length > 1) {
            this.navigateToTemplate3RootCategory(crumbItems[0]);
            return false;
        }
        if (crumbItems.length === 1) {
            this.navigateToMemberMenuHome();
            return true;
        }
        return null;
    };

    navigateToTemplate3RootCategory(rootCrumb) {
        if (!rootCrumb) {
            return;
        }
        const rootItem = this.crumbToMenuItem(rootCrumb);
        const rootId = rootCrumb.id;

        this.scrollMemberMenuToTop();
        this.bumpMemberMenuContext();
        this.setState({
            crumbItems: [rootCrumb],
            selectedCardId: null,
            offset: 0,
            allDataLoaded: false,
            subMenuChips: []
        }, () => {
            this.scrollMemberMenuToTop();
            this.getItemsFromDb(rootItem, rootId);
        });
    }

    handlePopState() {
        if (!this.isMemberStoreMenuActive()) {
            return;
        }
        if (GeneralUtils.isNullOrEmpty(localStorage.getItem("appMode")) || localStorage.getItem("appMode") !== "member") {
            return;
        }
        if (this.state.displayConfirmDialog) {
            this.setState({displayConfirmDialog: false});
            return;
        }
        if (this.state.displayDialog) {
            this.setState({displayDialog: false});
            return;
        }
        if (this.state.crumbItems.length > 0) {
            /* popstate zaten bir history kaydını tüketti; ek push/replace yok */
            this.handleMemberMenuBack();
            return;
        }
        if (this.state.showItems === false) {
            this.setState({showItems: true});
            return;
        }
        /* Ana menü: tarayıcı zaten önceki URL'ye gitti */
    }
    handleScroll = () => {
        this._lastWindowScrollAt = Date.now();
        if (this.state.displayDialog || this._bodyScrollLocked) {
            return;
        }
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100 &&
            !this.state.loading &&
            !this.state.allDataLoaded) {
            this.loadMoreProducts();
        }
    };

    loadInitialProducts = async () => {
        const { offset, limit } = this.state;
        const parentId = this.state.selectedMenu || -1;
        const epochAtRequest = this._menuSyncEpoch;
        const branchId = localStorage.getItem("merchantBranchId");
        if (!this.isValidMerchantBranchId(branchId)) {
            this.setState({ products: [], loading: false, allDataLoaded: true });
            return;
        }

        this.setState({ loading: true });

        const response = await this.webMenuMemberService.getWebMenuItemsByParentId(branchId, parentId, offset, limit);
        if (epochAtRequest !== this._menuSyncEpoch) {
            return;
        }
        if ((this.state.selectedMenu || -1) !== parentId) {
            return;
        }
        if (response && response.length > 0) {
            this.setState({
                products: response,
                offset: offset + limit,
                loading: false
            });
        } else {
            this.setState({ loading: false, allDataLoaded: true });
        }
    }

    loadMoreProducts = async () => {
        if (this._memberMenuLoadMoreLock) {
            return;
        }
        const { offset, limit, products, selectedMenu } = this.state;
        const parentId = selectedMenu || -1;
        const branchId = localStorage.getItem("merchantBranchId");
        if (!this.isValidMerchantBranchId(branchId)) {
            this.setState({ loading: false, allDataLoaded: true });
            return;
        }

        this._memberMenuLoadMoreLock = true;
        this.setState({ loading: true });

        try {
            const epochAtRequest = this._menuSyncEpoch;
            const response = await this.webMenuMemberService.getWebMenuItemsByParentId(branchId, parentId, offset, limit);
            if (epochAtRequest !== this._menuSyncEpoch) {
                return;
            }
            if ((this.state.selectedMenu || -1) !== parentId) {
                return;
            }
            if (response && response.length > 0) {
                const seen = new Set(
                    products.map((p) => (p.webMenuBssId != null ? p.webMenuBssId : p.id))
                );
                const appended = [];
                for (let i = 0; i < response.length; i++) {
                    const row = response[i];
                    const key = row.webMenuBssId != null ? row.webMenuBssId : row.id;
                    if (key == null) {
                        appended.push(row);
                    } else if (!seen.has(key)) {
                        seen.add(key);
                        appended.push(row);
                    }
                }
                this.setState({
                    products: appended.length ? [...products, ...appended] : products,
                    offset: offset + limit,
                    loading: false,
                    allDataLoaded: response.length < limit
                });
            } else {
                this.setState({ loading: false, allDataLoaded: true });
            }
        } finally {
            this._memberMenuLoadMoreLock = false;
        }
    }

    getProductsForHomeParent = () => {

        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("appMode")) && localStorage.getItem("appMode") == "member") {
            if (this.isValidMerchantBranchId(localStorage.getItem("merchantBranchId"))) {

                const epochAtRequest = this._menuSyncEpoch;
                const branchId = localStorage.getItem("merchantBranchId");
                const limit = this.state.limit;
                this.setState({ loading: true });
                this.webMenuMemberService.getWebMenuItemsByParentId(branchId, -1, 0, limit).then((response) => {
                    if (epochAtRequest !== this._menuSyncEpoch) {
                        return;
                    }
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                        this.setState({
                            products: response,
                            offset: limit,
                            loading: false,
                            allDataLoaded: !response.length || response.length < limit
                        });
                    } else {
                        this.setState({
                            products: [],
                            offset: 0,
                            loading: false,
                            allDataLoaded: true
                        });
                    }
                });


            }
        }

    }

    /**
     * App.js sets localStorage orderType when URL has tableBssId (Table Order).
     * If orderType is already stored and offered by this branch, keep it.
     * If not stored: one option → that option; multiple → Collection, Delivery, Table Order.
     */
    resolveOrderType(deliveryTypesList) {
        if (!deliveryTypesList || deliveryTypesList.length === 0) {
            return null;
        }

        const savedOrderType = localStorage.getItem("orderType");
        const hasStoredOrderType = !GeneralUtils.__isValueEmpty(savedOrderType) && savedOrderType !== "undefined";

        if (hasStoredOrderType && deliveryTypesList.some((item) => item.id === savedOrderType)) {
            return savedOrderType;
        }

        if (!hasStoredOrderType && !GeneralUtils.isNullOrEmpty(localStorage.getItem("tableBssId"))
            && deliveryTypesList.some((item) => item.id === "Table Order")) {
            return "Table Order";
        }

        if (deliveryTypesList.length === 1) {
            return deliveryTypesList[0].id;
        }

        const priority = ["Collection", "Delivery", "Table Order"];
        for (let i = 0; i < priority.length; i++) {
            if (deliveryTypesList.some((item) => item.id === priority[i])) {
                return priority[i];
            }
        }
        return deliveryTypesList[0].id;
    }

    syncMemberLicenses = async (merchantBranchId) => {
        if (!this.isValidMerchantBranchId(merchantBranchId)) {
            return null;
        }
        const licenseResponse = await this.licenseService.getLicenses(merchantBranchId);
        if (!GeneralUtils.isNullOrEmpty(licenseResponse) && GeneralUtils.isNullOrEmpty(licenseResponse.type)) {
            localStorage.setItem("WEB_ORDER_LICENSE", licenseResponse.hasWebOrderLicense);
            localStorage.setItem("WEB_MENU_LICENSE", licenseResponse.hasWebMenuLicense);
            localStorage.setItem("TABLE_ORDER_LICENSE", licenseResponse.hasTableOrderLicense);
            localStorage.setItem("HIDE_PRICE_FOR_WEBMENU", licenseResponse.hidePriceForWebMenu);
        }
        return licenseResponse;
    }

    async getDeliveryTypes() {
        var array = [];
        var hasDeliveryOrderType = false;
        const merchantBranchId = localStorage.getItem("merchantBranchId");
        if (!this.isValidMerchantBranchId(merchantBranchId)) {
            this.setState({orderType: null, deliveryTypesList: [], hasDeliveryOrderType: false});
            return;
        }
        const licenseResponse = await this.syncMemberLicenses(merchantBranchId);
        const response = (await this.merchantBranchSettingsService.findByBranchIdForMember(merchantBranchId));
        const hasWebOrderLicense = !!(licenseResponse && licenseResponse.hasWebOrderLicense);
        const hasTableOrderLicense = !!(licenseResponse && licenseResponse.hasTableOrderLicense);

        if (hasWebOrderLicense) {

            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                hasDeliveryOrderType = response.hasDeliveryOrderType;
                if (!GeneralUtils.isNullOrEmpty(response.webOrderPaymentOptions)) {

                    var nameArr = response.webOrderPaymentOptions.split(',');
                    for (var i = 0; i < nameArr.length; i++) {
                        if (nameArr[i].indexOf("DELIVERY") > 0) {
                            array.push({
                                name: "Delivery", id: "Delivery"
                            });
                            break;
                        }

                    }

                    for (var i = 0; i < nameArr.length; i++) {
                        if (nameArr[i].indexOf("COLLECTION") > 0) {
                            array.push({
                                name: "Collection", id: "Collection"
                            });
                            break;
                        }

                    }
                }
            }


        }

        if (hasTableOrderLicense) {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                hasDeliveryOrderType = response.hasDeliveryOrderType;
                if (!GeneralUtils.isNullOrEmpty(response.tableOrderPaymentOptions)) {
                    array.push({
                        name: "Table Order", id: "Table Order"
                    });
                }
            }

        }
        const orderType = this.resolveOrderType(array);
        if (!GeneralUtils.isNullOrEmpty(orderType)) {
            localStorage.setItem("orderType", orderType);
        }
        this.setState({orderType: orderType, deliveryTypesList: array, hasDeliveryOrderType: hasDeliveryOrderType});
    }


    getWebMenuList = (onComplete) => {
        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("appMode")) && localStorage.getItem("appMode") == "member") {
            if (this.isValidMerchantBranchId(localStorage.getItem("merchantBranchId"))) {
                const epochAtRequest = this._menuSyncEpoch;
                this.setState({loading: true});
                return this.webMenuMemberService.getActiveWebMenuShortcutsForMemberByBranchId(localStorage.getItem("merchantBranchId")).then(response => {
                    if (epochAtRequest !== this._menuSyncEpoch) {
                        return false;
                    }
                    // Geç gelen kök menü cevabı, kullanıcı alt kategoriye (ör. Beer) geçmişken
                    // breadcrumb doğru olsa bile shortcuts'ı ana menüye döndürmesin.
                    if ((this.state.crumbItems && this.state.crumbItems.length > 0) || this.state.selectedMenu != null) {
                        this.setState({loading: false});
                        return false;
                    }
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            shortcuts: response,
                            loading: false
                        });
                    } else {
                        this.setState({
                            shortcuts: [],
                            loading: false
                        });
                    }
                    return true;
                }).then((shouldLoadProducts) => {
                    if (shouldLoadProducts && typeof onComplete === 'function') {
                        onComplete();
                    }
                });
            }
        }
        return Promise.resolve();
    }

    setQuantitiesToCart(response) {
        let basketDetailList = response.basketDetailList;
        let products = this.state.products;
        for (var i = 0; i < products.length; i++) {
            products[i].basketQuantity = null;
            for (var j = 0; j < basketDetailList.length; j++) {

                if (products[i].webMenuBssId == basketDetailList[j].webMenuBssId) {
                    if (GeneralUtils.isSetMenu(basketDetailList[j])) {
                        let sum = 0;
                        basketDetailList.forEach(item => {
                            if (item.webMenuBssId == products[i].webMenuBssId) {
                                sum += item.quantity;
                            }
                        })
                        products[i].basketQuantity = sum;
                    } else {
                        products[i].basketQuantity = basketDetailList[j].quantity;
                    }

                }
            }
        }
        this.setState({products: products});
    }

    getBasketInfo = async (basketResponse) => {
        if (!this.isValidMerchantBranchId(localStorage.getItem("merchantBranchId"))) {
            return;
        }
        if ((GeneralUtils.hasWebOrderLicense() || GeneralUtils.hasTableOrderLicense())) {
            const epochAtStart = this._menuSyncEpoch;
            const selectedSnap = this.state.selectedMenu;
            const crumbSnap = this.state.crumbItems.map(c => String(c.id)).join(',');
            const response = basketResponse || (await this.basketService.findBasketCreatedByMerchantBranchId(localStorage.getItem("merchantBranchId"), null));
            if (epochAtStart !== this._menuSyncEpoch) {
                return;
            }
            if (selectedSnap !== this.state.selectedMenu) {
                return;
            }
            if (crumbSnap !== this.state.crumbItems.map(c => String(c.id)).join(',')) {
                return;
            }
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setQuantitiesToCart(response);
                if (this.refOrderCheckout != null) {
                    this.refOrderCheckout.setPageMode(PAGE_MODE.CREATE);
                    this.refOrderCheckout.setData(response);
                    if (this.refAppFooterMember != null) {
                        this.refAppFooterMember.setDataFromBasket(response);
                    }
                }
            }
        }
    }

    isValidMerchantBranchId(branchId) {
        if (GeneralUtils.isNullOrEmpty(branchId)) {
            return false;
        }
        const s = String(branchId).trim();
        return !(s === "-1" || s === "null");
    }

    productItemTemplate2(item) {

        let maxWidth = "11rem";
        const hasImage = this.hasValidProductImage(item);

        if (GeneralUtils.isMobile()) {
            maxWidth = "10rem";
        }


        return <div className="product-item2-wrap" style={{overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', height: '100%', minWidth: 0}}>

            <div className={`product-item2 ${hasImage ? "" : "product-item2--no-image"}`} style={{
                "--member-accent": this.getBackGroundColor()
            }}>

                {hasImage && (
                <Row>
                    <div className="image-container">
                        <img
                            src={this.getProductImageSrc(item)}
                            onError={() => this.markProductImageBroken(item)}
                            alt={item.name}/>
                    </div>
                </Row>
                )}
                <div className="product-item2__body" style={{
                    textAlign: "center",
                    maxWidth: maxWidth,
                    width: "100%",
                    margin: "0 auto"
                }}>

                    <Row>

                        <Col>
                            {!GeneralUtils.isNullOrEmpty(item.basketQuantity) &&
                                <h6 style={{
                                    fontWeight: "bold",
                                    margin: 0,
                                    lineHeight: "1.2",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere"
                                }}>{item.name}&nbsp;&nbsp;<Chip
                                    label={item.basketQuantity}
                                    style={{
                                        backgroundColor: this.getBackGroundColor(),
                                        zoom: "0.7",
                                        color: "white"
                                    }}/>&nbsp;&nbsp;</h6>
                            }
                            {GeneralUtils.isNullOrEmpty(item.basketQuantity) &&
                                <h6 style={{
                                    fontWeight: "bold",
                                    margin: 0,
                                    lineHeight: "1.2",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflowWrap: "anywhere"
                                }}>{item.name}</h6>
                            }

                        </Col>
                    </Row>


                    <Row>
                        <Col>

                            {localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") != "true" && !GeneralUtils.isNullOrEmpty(item.price) &&
                                <h6 className="product-item-price">£{item.price.toFixed(2)}</h6>}

                        </Col>

                    </Row>

                    <Row>


                        <div style={{float: "right", marginLeft: "auto"}}>
                            {this.renderAddToCartButtons(item)}

                        </div>

                    </Row>


                </div>


            </div>

        </div>

    }

    renderAddToCartButtons(item) {
        let marginRight = "0.5rem";
        if (GeneralUtils.isMobile()) {
            marginRight = "0.5rem";
        }

        const canOrder = GeneralUtils.hasTableOrderLicense() || GeneralUtils.hasWebOrderLicense();
        const showInfo = (!canOrder && GeneralUtils.hasWebMenuLicense()) && GeneralUtils.isSetMenu(item);
        const productOpenGestureProps = {
            onPointerDown: this.onProductOpenPointerDown,
            onPointerMove: this.onProductOpenPointerMove,
            onPointerCancel: this.onProductOpenPointerCancel,
            onTouchStart: this.onProductOpenPointerDown,
            onTouchMove: this.onProductOpenPointerMove,
            onTouchCancel: this.onProductOpenPointerCancel
        };

        if (this.isTemplate3()) {
            return (
                <div className="product-item__actions">
                    {canOrder && this.renderAddToChartButton(item)}
                    {showInfo &&
                        <Button type="button" icon={"pi pi-info-circle"}
                                style={{
                                    border: '0px solid #1982D9',
                                    boxShadow: '0px 0px 0px 0px #ccc',
                                    zoom: '1.5'
                                }}
                                {...productOpenGestureProps}
                                onClick={() => {
                                    this.openProductDialogFromList(true, () => {
                                        this.itemsDetail.clearData(Object.assign({}, item), true);
                                    });
                                }}></Button>
                    }
                </div>
            );
        }

        if (this.state.addressInfo.menuDisplayTemplate === "Template1") {
            return (
                <div className="product-item__actions">
                    {canOrder && this.renderAddToChartButton(item)}
                    {showInfo &&
                        <Button type="button" icon={"pi pi-info-circle"}
                                style={{
                                    border: '0px solid #1982D9',
                                    boxShadow: '0px 0px 0px 0px #ccc',
                                    zoom: '1.5'
                                }}
                                {...productOpenGestureProps}
                                onClick={() => {
                                    this.openProductDialogFromList(true, () => {
                                        this.itemsDetail.clearData(Object.assign({}, item), true);
                                    });
                                }}></Button>
                    }
                </div>
            );
        }

        return <>
            <div>
                {GeneralUtils.isAuthenticated() && canOrder && this.renderAddToChartButton(item)}
            </div>
            <div>
                {!GeneralUtils.isAuthenticated() && canOrder && this.renderAddToChartButton(item)}
            </div>
            {showInfo &&
                <div>
                    <Button type="button" icon={"pi pi-info-circle"}
                            style={{
                                border: '0px solid #1982D9',
                                boxShadow: '0px 0px 0px 0px #ccc',
                                marginRight: this.state.addressInfo.menuDisplayTemplate == "Template2" ? marginRight : 0,
                                zoom: '1.5'
                            }}
                            {...productOpenGestureProps}
                            onClick={() => {
                                this.openProductDialogFromList(true, () => {
                                    this.itemsDetail.clearData(Object.assign({}, item), true);
                                });
                            }}></Button>
                </div>
            }
        </>;
    }

    isTemplate3() {
        const template = this.state.addressInfo && this.state.addressInfo.menuDisplayTemplate;
        return template === "Template3";
    }

    usesProductCardSkeleton() {
        const template = this.state.addressInfo && this.state.addressInfo.menuDisplayTemplate;
        return template === "Template1" || template === "Template3";
    }

    isParentMenuLevel() {
        return this.state.crumbItems.length === 0 && this.state.searchText.length <= 3;
    }

    getItemDetailsDialogPosition() {
        if (this.isMemberMenuNarrowViewport()) {
            return "bottom";
        }
        return "center";
    }

    getItemDetailsDialogStyle() {
        const accentStyle = {"--item-accent": this.getMenuBorderColor()};
        if (this.isMemberMenuNarrowViewport()) {
            return {width: "100%", height: "auto", maxHeight: "92vh", margin: 0, ...accentStyle};
        }
        if (this.isTemplate3()) {
            const baseStyle = this.state.isSetMenu
                ? GeneralUtils.getDialogStyleForDialog()
                : GeneralUtils.getDialogStyleForProduct();
            return {...baseStyle, ...accentStyle};
        }
        return {
            width: "min(520px, 92vw)",
            maxWidth: "520px",
            height: "auto",
            maxHeight: "82vh",
            marginLeft: "auto",
            marginRight: "auto",
            ...accentStyle
        };
    }

    getItemDetailsDialogClassName() {
        const classes = ["item-details-dialog-root"];
        if (this.isTemplate3()) {
            classes.push("item-details-dialog-root--template3");
        } else {
            classes.push("item-details-dialog-root--legacy");
        }
        if (this.isMemberMenuNarrowViewport()) {
            classes.push("item-details-dialog-root--mobile-sheet");
        }
        return classes.join(" ");
    }

    isMemberMenuNarrowViewport() {
        if (GeneralUtils.isMobile()) {
            return true;
        }
        if (typeof window !== "undefined" && window.innerWidth > 0) {
            return window.innerWidth <= 576;
        }
        return false;
    }

    productItemTemplate1(item) {
        let className = "pi pi-chevron-right product-category-icon";
        const hasImage = this.hasValidProductImage(item);
        const hidePrice = localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") === "true";
        const hasDescription = !GeneralUtils.isNullOrEmpty(item.grpContentText);

        return <div className="product-item-wrap product-item-wrap--template1" style={{width: '100%', minWidth: 0}}>
            <div className={`product-item ${hasImage ? "" : "product-item--no-image"}`} style={{"--member-accent": this.getBackGroundColor()}}>
                <div className="product-item__content">
                    {hasImage && (
                    <div className="image-container">
                        <img
                            src={this.getProductImageSrc(item)}
                            onError={() => this.markProductImageBroken(item)}
                            alt={item.name}/>
                    </div>
                    )}

                    <div className="product-item__body">
                        <div className="product-item__header">
                            <div className="product-item__name">
                                {item.name}
                                {!GeneralUtils.isNullOrEmpty(item.basketQuantity) &&
                                    <Chip label={item.basketQuantity}
                                          style={{
                                              backgroundColor: this.getBackGroundColor(),
                                              zoom: "0.7",
                                              color: "white",
                                              marginLeft: "0.35rem"
                                          }}/>
                                }
                            </div>
                            {!hidePrice && !GeneralUtils.isNullOrEmpty(item.price) &&
                                <div className="product-item__price">£{item.price.toFixed(2)}</div>
                            }
                        </div>

                        {hasDescription ? (
                            <div className="product-item-desc-wrap product-item__desc">
                                <i className={className}></i>
                                <span className="product-item-desc">{item.grpContentText}</span>
                            </div>
                        ) : (
                            <div className="product-item__desc product-item__desc--empty" aria-hidden="true"/>
                        )}
                    </div>
                </div>

                <div className="product-item__footer">
                    {this.renderAddToCartButtons(item)}
                </div>
            </div>
        </div>;
    }

    productItemTemplate3(item) {
        const hasImage = this.hasValidProductImage(item);
        const accent = this.getMenuBorderColor();
        const hidePrice = localStorage.getItem("HIDE_PRICE_FOR_WEBMENU") === "true";
        const hasDescription = !GeneralUtils.isNullOrEmpty(item.grpContentText);

        return (
            <div className="product-item-wrap">
                <div
                    className={`product-item ${hasImage ? "product-item--with-image" : "product-item--no-image"}`}
                    style={{"--member-accent": accent}}
                >
                    <div className="product-item__content">
                        {hasImage ? (
                            <div className="product-item__media">
                                <img
                                    src={this.getProductImageSrc(item)}
                                    onError={() => this.markProductImageBroken(item)}
                                    alt={item.name}
                                />
                            </div>
                        ) : (
                            <div className="product-item__media-spacer" aria-hidden="true"/>
                        )}

                        <div className="product-item__body">
                            <div className="product-item__header">
                                <div className="product-item__name">
                                    {item.name}
                                    {!GeneralUtils.isNullOrEmpty(item.basketQuantity) && (
                                        <Chip
                                            label={item.basketQuantity}
                                            style={{
                                                backgroundColor: accent,
                                                zoom: "0.7",
                                                color: "white",
                                                marginLeft: "0.35rem"
                                            }}
                                        />
                                    )}
                                </div>
                                {!hidePrice && !GeneralUtils.isNullOrEmpty(item.price) && (
                                    <div className="product-item__price">£{item.price.toFixed(2)}</div>
                                )}
                            </div>

                            {hasDescription ? (
                                <div className="product-item__desc">
                                    <i className="pi pi-chevron-right product-item__desc-icon" aria-hidden="true"/>
                                    <span>{item.grpContentText}</span>
                                </div>
                            ) : (
                                <div className="product-item__desc product-item__desc--empty" aria-hidden="true"/>
                            )}
                        </div>
                    </div>

                    <div className="product-item__footer">
                        {this.renderAddToCartButtons(item)}
                    </div>
                </div>
            </div>
        );
    }

    productItem(item) {
        const template = this.state.addressInfo.menuDisplayTemplate;
        if (template === "Template2") {
            return this.productItemTemplate2(item);
        }
        if (template === "Template3") {
            return this.productItemTemplate3(item);
        }
        return this.productItemTemplate1(item);
    }

    renderTemplate3ChipSkeleton(count = 4) {
        const items = [];
        for (let i = 0; i < count; i++) {
            items.push(
                <div
                    key={`chip-sk-${i}`}
                    className="member-submenu-tab member-submenu-tab--skeleton skeleton-shimmer"
                    aria-hidden="true"
                />
            );
        }
        return items;
    }

    renderTemplate1ProductSkeleton(skeletonKey) {
        return (
            <div
                key={skeletonKey}
                className="product-item-wrap product-item-wrap--template1 product-item-wrap--skeleton"
                aria-hidden="true"
            >
                <div className="product-item product-item--skeleton">
                    <div className="product-item__content">
                        <div className="image-container product-item__skeleton-media skeleton-shimmer"/>
                        <div className="product-item__body">
                            <div className="product-item__header">
                                <div className="product-item__skeleton-line product-item__skeleton-line--title skeleton-shimmer"/>
                                <div className="product-item__skeleton-line product-item__skeleton-line--price skeleton-shimmer"/>
                            </div>
                            <div className="product-item__skeleton-line product-item__skeleton-line--desc skeleton-shimmer"/>
                        </div>
                    </div>
                    <div className="product-item__footer">
                        <div className="product-item__skeleton-btn skeleton-shimmer"/>
                    </div>
                </div>
            </div>
        );
    }

    renderTemplate3ProductSkeleton(skeletonKey) {
        return (
            <div key={skeletonKey} className="product-item-wrap product-item-wrap--skeleton" aria-hidden="true">
                <div className="product-item product-item--skeleton product-item--no-image">
                    <div className="product-item__content">
                        <div className="product-item__media-spacer product-item__skeleton-media skeleton-shimmer"/>
                        <div className="product-item__body">
                            <div className="product-item__header">
                                <div className="product-item__skeleton-line product-item__skeleton-line--title skeleton-shimmer"/>
                                <div className="product-item__skeleton-line product-item__skeleton-line--price skeleton-shimmer"/>
                            </div>
                            <div className="product-item__skeleton-line product-item__skeleton-line--desc skeleton-shimmer"/>
                        </div>
                    </div>
                    <div className="product-item__footer">
                        <div className="product-item__skeleton-btn skeleton-shimmer"/>
                    </div>
                </div>
            </div>
        );
    }

    renderProductSkeletonGrid(listStyle, count = 6, append = false) {
        const renderSkeleton = this.isTemplate3()
            ? this.renderTemplate3ProductSkeleton.bind(this)
            : this.renderTemplate1ProductSkeleton.bind(this);
        const items = [];
        for (let i = 0; i < count; i++) {
            items.push(renderSkeleton(`sk-${append ? "more-" : ""}${i}`));
        }
        return (
            <div
                className={`product-skeleton-grid${this.isTemplate3() ? " product-skeleton-grid--template3" : " product-skeleton-grid--template1"}${append ? " product-skeleton-grid--append" : ""}`}
                style={listStyle}
                aria-busy="true"
                aria-label="Loading menu items"
            >
                {items}
            </div>
        );
    }

    renderTemplate3ProductSkeletonGrid(listStyle, count = 6, append = false) {
        return this.renderProductSkeletonGrid(listStyle, count, append);
    }

    getTemplate3ListStyle() {
        let listStyle = {
            height: "auto",
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            display: "grid",
            gap: "12px 16px",
            alignItems: "stretch",
            width: "100%"
        };
        if (this.isMemberMenuNarrowViewport()) {
            listStyle = {
                height: "auto",
                display: "grid",
                gridTemplateColumns: "minmax(0, 1fr)",
                gap: "10px",
                alignItems: "stretch",
                width: "100%"
            };
        }
        return listStyle;
    }

    getProductImageKey(item) {
        return item && (item.id || item.webMenuItemBssId || item.webMenuBssId || item.name);
    }

    resolveProductImagePath(item) {
        if (GeneralUtils.isNullOrEmpty(item)) {
            return null;
        }
        if (!GeneralUtils.isNullOrEmpty(item.webImagePath)) {
            return item.webImagePath;
        }
        if (!GeneralUtils.isNullOrEmpty(item.productWebImagePath)) {
            return item.productWebImagePath;
        }
        return null;
    }

    getProductImageSrc(item) {
        const imagePath = this.resolveProductImagePath(item);
        if (GeneralUtils.isNullOrEmpty(imagePath)) {
            return null;
        }
        return WEB_IMAGE_SERVER_URL + imagePath;
    }

    hasValidProductImage(item) {
        const imagePath = this.resolveProductImagePath(item);
        if (GeneralUtils.isNullOrEmpty(imagePath)) {
            return false;
        }
        const key = this.getProductImageKey(item);
        if (GeneralUtils.isNullOrEmpty(key)) {
            return true;
        }
        return this.state.brokenImageMap[key] !== true;
    }

    markProductImageBroken(item) {
        const key = this.getProductImageKey(item);
        if (GeneralUtils.isNullOrEmpty(key)) {
            return;
        }
        if (this.state.brokenImageMap[key] === true) {
            return;
        }
        this.setState(prevState => ({
            brokenImageMap: {
                ...prevState.brokenImageMap,
                [key]: true
            }
        }));
    }

    addProductToCart = (item) => {
        this.refOrderCheckout.addItem(item)
        this.setState({displayDialog: false})
    }

    addItemToCart(item) {

        var validations = this.checkDeliveryPostCodeIsValid();
        if (GeneralUtils.isNullOrEmpty(validations)) {
            if (GeneralUtils.isSetMenu(item)

            ) {
                this.openProductDialog(true, () => {
                    this.itemsDetail.clearData(Object.assign({}, item), false);
                });
            } else {
                this.openProductDialog(false, () => {
                    this.itemsDetail.clearData(Object.assign({}, item), false);
                });
            }
        } else {
            return toast.warn(validations);
        }


    }

    showConfirmDialog = (item) => {
        if (this.shouldIgnoreProductOpenFromGesture()) {
            return;
        }
        const openToken = ++this._productOpenToken;
        const scrollYAtOpen = window.scrollY || window.pageYOffset || 0;
        const openedAt = Date.now();

        this.merchantBranchSettingsService.isStoreClosed(localStorage.getItem("merchantBranchId")).then((response) => {
            if (openToken !== this._productOpenToken) {
                return;
            }
            if (Math.abs((window.scrollY || window.pageYOffset || 0) - scrollYAtOpen) > 10) {
                return;
            }
            if (this._lastWindowScrollAt > openedAt && (Date.now() - this._lastWindowScrollAt) < 200) {
                return;
            }
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                if (item.ageRestricted) {
                    this.basketService.checkAgeRestricted(localStorage.getItem("merchantBranchId")).then((ageResponse) => {
                        if (openToken !== this._productOpenToken) {
                            return;
                        }
                        if (ageResponse == false) {
                            this.setState({
                                displayConfirmDialog: true,
                                item: item,
                                noticeResponse: "The item you want to add has an age limit. Are you over 18?"
                            }, () => {
                                this.pushMemberMenuHistoryState();
                            });
                        } else {
                            this.addItemToCart(item)
                        }
                    });
                } else {
                    this.addItemToCart(item)
                }
            }

        });

    }

    ageRestricted = (item) => {
        this.basketService.ageRestricted(localStorage.getItem("merchantBranchId")).then((response) => {
            if (!GeneralUtils.isNullOrEmpty(response)) {
                this.addItemToCart(item);
            }
        });
    }

    renderAddToChartButton(item) {
        let form = [];
        const menuColor = this.getMenuBorderColor();
        const useModernAddBtn = this.isTemplate3()
            || this.state.addressInfo.menuDisplayTemplate === "Template1";
        const productOpenGestureProps = {
            onPointerDown: this.onProductOpenPointerDown,
            onPointerMove: this.onProductOpenPointerMove,
            onPointerCancel: this.onProductOpenPointerCancel,
            onTouchStart: this.onProductOpenPointerDown,
            onTouchMove: this.onProductOpenPointerMove,
            onTouchCancel: this.onProductOpenPointerCancel
        };

        if (useModernAddBtn) {
            form.push(
                <button
                    type="button"
                    className="member-add-btn member-add-btn--template3"
                    style={{"--member-accent": menuColor}}
                    {...productOpenGestureProps}
                    onClick={() => this.showConfirmDialog(item)}
                    aria-label="Add to cart"
                >
                    <span className="member-add-btn__plus" style={{color: menuColor}} aria-hidden="true">+</span>
                </button>
            );
            return form;
        }

        let marginRight = "0.5rem";
        if (GeneralUtils.isMobile()) {
            marginRight = "0.5rem";
        }

        form.push(<Button type="button" icon={"pi pi-plus"} className="member-add-btn"
                          style={{
                              border: '0px solid #1982D9',
                              boxShadow: '0px 0px 0px 0px #ccc',
                              zoom: '1.5',
                              marginRight: this.state.addressInfo.menuDisplayTemplate == "Template2" ? marginRight : 0,
                          }}
                          {...productOpenGestureProps}
                          onClick={() => {
                              this.showConfirmDialog(item);
                          }}></Button>);

        return form;
    }

    closeDisplayDialog = () => {
        this.setState({displayDialog: false});
    }

    openItemDetails = (data) => {
        this.openProductDialog(true, () => {
            this.itemsDetail.setData(Object.assign({}, data));
        });
    }

    addSetMenuItem = (item) => {
        this.refOrderCheckout.addItemSetMenu(item);
        this.setState({displayDialog: false});
    }

    __handleChangeSearchText = async (e) => {
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        const branchId = localStorage.getItem("merchantBranchId");
        const limit = this.state.limit;

        this.setState({
            searchText: value,
            index: -1,
            offset: 0,
            products: [],
            loading: true,
            allDataLoaded: false
        });

        if (!GeneralUtils.isNullOrEmpty(value) && value.length > 3) {
            if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("appMode")) && localStorage.getItem("appMode") === "member") {
                this.bumpMemberMenuContext();
                const epochAtRequest = this._menuSyncEpoch;
                const response = await this.webMenuMemberService.findBySearchText(branchId, value);

                if (epochAtRequest !== this._menuSyncEpoch) {
                    return;
                }

                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                    this.setState({
                        products: response,
                        loading: false
                    });
                } else {
                    this.setState({
                        products: [],
                        loading: false,
                    });
                }
            }
        } else {
            // arama iptal edildi, mevcut menüye geri dön
            if (this.state.index !== this.state.indexTemp) {
                this.setState({
                    index: this.state.indexTemp,
                    loading: true,
                    products: [],
                    offset: 0,
                    allDataLoaded: false
                });

                if (this.state.indexTemp < this.state.crumbItems.length) {
                    this.bumpMemberMenuContext();
                    const epochAtRequest = this._menuSyncEpoch;
                    const crumbParentId = this.state.crumbItems[this.state.indexTemp].id;
                    const response = await this.webMenuMemberService.getWebMenuItemsByParentId(
                        branchId,
                        crumbParentId,
                        0,
                        limit
                    );

                    if (epochAtRequest !== this._menuSyncEpoch) {
                        return;
                    }
                    if (
                        !this.state.crumbItems[this.state.indexTemp] ||
                        this.state.crumbItems[this.state.indexTemp].id !== crumbParentId
                    ) {
                        return;
                    }

                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                        this.setState({
                            products: response,
                            offset: limit,
                            loading: false
                        });
                    } else {
                        this.setState({
                            products: [],
                            loading: false,
                            allDataLoaded: true
                        });
                    }
                } else {
                    this.bumpMemberMenuContext();
                    this.getWebMenuList(); // anasayfa
                }
            }
        }
    }


    async getLogo(merchantBranchId) {

        if (merchantBranchId == null || merchantBranchId == -1) {
            GeneralUtils.clearMemberStoreNames();
            return;
        }

        if (merchantBranchId != null && merchantBranchId != -1) {
            this.setState({logo: this.pageSettingsService.getStoreLogoUrl(merchantBranchId)});
            this.merchantBranchService.getStoreInfo(merchantBranchId).then(response => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({addressInfo: response});
                        GeneralUtils.persistMemberStoreNamesFromStoreInfo(response);
                    }
                }
            )
        }


    }

    renderStoreInfo() {
        if (GeneralUtils.isNullOrEmpty(this.state.addressInfo.addressText)) {
            return null;
        }
        return (
            <span className="member-store-address-row">
                <i className="material-icons member-store-address-row__icon" aria-hidden="true">location_on</i>
                <span className="member-store-address-row__text">{this.state.addressInfo.addressText}</span>
            </span>
        );
    }

    renderDeliveryInfo() {
        if (!GeneralUtils.isNullOrEmpty(this.state.addressInfo.minimumDeliveryDeliveryDuration) && !GeneralUtils.isNullOrEmpty(this.state.addressInfo.maximumDeliveryDeliveryDuration)) {
            return (
                <div><i class="material-icons" style={{fontSize: "14px"}}>schedule</i>
                    <span>&nbsp;{this.state.addressInfo.minimumDeliveryDeliveryDuration}&nbsp;-&nbsp;{this.state.addressInfo.maximumDeliveryDeliveryDuration}&nbsp;mins
        </span>
                </div>);
        }


    }

    getStoreStatusPresentation = () => {
        const rawMessage = this.state.addressInfo && this.state.addressInfo.storeOpenOrCloseMessageText
            ? String(this.state.addressInfo.storeOpenOrCloseMessageText).trim()
            : '';

        if (GeneralUtils.isNullOrEmpty(rawMessage)) {
            return null;
        }

        const lowerCaseMessage = rawMessage.toLowerCase();
        const isClosed = lowerCaseMessage.includes('closed');
        const isOpen = lowerCaseMessage.includes('open now')
            || (lowerCaseMessage.includes('open') && !isClosed);

        const openAtMatch = rawMessage.match(/(?:will open at|opens at)\s+(.+)$/i);
        if (isClosed && openAtMatch && openAtMatch[1]) {
            return {
                text: `Closed - Opens at ${openAtMatch[1].trim()}`,
                color: '#b00020'
            };
        }

        if (isClosed) {
            return {
                text: 'Closed',
                color: '#b00020'
            };
        }

        if (isOpen) {
            return {
                text: 'Open now',
                color: '#1b8f2e'
            };
        }

        return {
            text: rawMessage,
            color: '#333333'
        };
    }

    renderStoreContactInfo() {

        if (!GeneralUtils.isNullOrEmpty(this.state.addressInfo.contactEmail)) {

            return (
                <div>

                    <p></p>
                    <i class="material-icons" style={{fontSize: "14px"}}>mail</i>
                    <span>&nbsp;{this.state.addressInfo.contactEmail}
        </span>
                </div>);


        }

    }

    renderStoreInfoAndSearchText() {

        let form = [];
        let height = 100;
        let width = 100;
        let topImage = -45;
        let top = -55;
        let imageCardWidth = "100%";
        let searchTextTop = "-60px"
        if (GeneralUtils.isMobile()) {
            height = 58;
            width = 58;
            topImage = -29;
            top = -14;
            imageCardWidth = "95%";
            searchTextTop = "0px"
        }
        let header = null;
        if (!GeneralUtils.isNullOrEmpty(this.state.logo)) {
            header = (
                <img
                    src={this.state.logo}
                    className="member-store-logo"
                    style={{
                    height: height + 'px',
                    width: width + 'px',
                    alignContent: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                    position: "relative",
                    top: topImage,
                    zIndex: 25
                }} onError={() => this.setState({logo: null})}/>
            );
        }


        const statusPresentation = this.getStoreStatusPresentation();
        const hasOnlineOrderingExtra = !GeneralUtils.isNullOrEmpty(this.state.addressInfo.onlineOrderingMessageText);
        const hasOrderingWindowHint = !GeneralUtils.isNullOrEmpty(this.state.addressInfo.onlineOrderingWindowHintText);
        const openNowGreen = '#1b8f2e';

        form.push(
            <div align={"center"} style={{
                borderWidth: "0",
                top: top + "px",
                width: imageCardWidth,
                margin: "auto",
                position: "relative",
                zIndex: 15
            }}>
                <Card style={{borderLeft: "none"}} title={this.state.addressInfo.tradingName}
                      header={header} className="md:w-5rem">
                    <p className="m-0">
                        <span style={{
                            color: statusPresentation ? statusPresentation.color : '#333333',
                            fontWeight: 600
                        }}>
                            {statusPresentation ? statusPresentation.text : ''}
                        </span>
                        {hasOnlineOrderingExtra && (
                            <span
                                className="member-store-order-hint"
                                style={{
                                    display: 'block',
                                    marginTop: '6px',
                                    color: openNowGreen,
                                    fontWeight: 600,
                                    fontSize: 'inherit',
                                    fontFamily: 'inherit',
                                    letterSpacing: '0.01em'
                                }}>
                                {this.state.addressInfo.onlineOrderingMessageText}
                            </span>
                        )}
                        {hasOrderingWindowHint && (
                            <span style={{
                                display: 'block',
                                marginTop: hasOnlineOrderingExtra ? '4px' : '6px',
                                color: '#5c5c5c',
                                fontWeight: 600,
                                fontSize: 'inherit',
                                fontFamily: 'inherit',
                                letterSpacing: '0.01em'
                            }}>
                                {this.state.addressInfo.onlineOrderingWindowHintText}
                            </span>
                        )}
                        <p></p>
                        {this.renderStoreInfo()}<p></p>
                        {this.renderDeliveryInfo()}<p></p>
                        {this.renderStoreContactInfo()}
                    </p>
                </Card></div>);

        form.push(<p></p>);
        form.push(
            <div
                className="member-store-controls"
                style={{
                    backgroundColor: '#FFFFFF',
                    top: searchTextTop,
                    position: "relative",
                }}>

                {this.state.deliveryTypesList.length > 1 &&
                    <div className="member-delivery-types-wrap">
                        {this.renderDeliveryTypes()}
                    </div>
                }
                {this.state.orderType == "Delivery" &&
                    <div className="member-store-field-row member-store-field-row--postcode">
                        <div className="member-store-field-input-wrap">
                            <Dropdown ref={elem => this.dropDownAddress = elem}
                                      value={this.state.postCode}
                                      name="postCode"
                                      style={{width: "100%"}}
                                      showOnFocus={false}
                                      className="member-store-search-dropdown"
                                      disabled={false}
                                      options={this.state.filteredAddresses}
                                      onChange={this.__handleChangeAddress}
                                      optionLabel="displayString"
                                      dataKey="udprn"
                                      appendTo={typeof document !== "undefined" ? document.body : null}
                                      editable
                                      placeholder="Postcode"/>
                        </div>
                        <button
                            type="button"
                            className="member-store-field-action-btn"
                            aria-label="Search postcode"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                this.searchAddress(e);
                            }}
                        >
                            <i className="pi pi-search" aria-hidden="true"/>
                        </button>
                    </div>
                }

                <div className="member-store-field-row">
                    <InputText
                        value={this.state.searchText}
                        className="member-store-search-input"
                        placeholder="Search"
                        onChange={this.__handleChangeSearchText}/>
                </div>
            </div>
        );


        return form;

    }

    setDeliveryAddressDetailToLocalStorage(data) {
        localStorage.setItem("postCode", data.postCode);
        localStorage.setItem("description", data.postCode);
        localStorage.setItem("addressLine1", data.addressLines[0]);
        localStorage.setItem("addressLine2", data.addressLines[1]);
        localStorage.setItem("addressLine3", data.addressLines[2]);
        localStorage.setItem("addressLine4", data.addressLines[3]);
        localStorage.setItem("city", data.postTown);
        localStorage.setItem("displayAddressString", data.displayString);
    }


    __handleChangeAddress = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let postCodeTemp = null;

        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("postCodeTemp")) && localStorage.getItem("postCodeTemp") != "undefined") {
            postCodeTemp = localStorage.getItem("postCodeTemp");
        }
        if (GeneralUtils.isNullOrEmpty(postCodeTemp) && value.postCode != undefined && !GeneralUtils.isNullOrEmpty(value)) {
            this.setState({postCode: value});
            this.setState({servicableThisPostCode: false});
            this.addressService.isServicableThisPostCode(localStorage.getItem("merchantBranchId"), value.postCode).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status) && GeneralUtils.isNullOrEmpty(response.message)) {
                    this.setDeliveryAddressDetailToLocalStorage(value);
                    this.setState({servicableThisPostCode: response, postCodeTemp: value.postCode});

                } else {
                    this.setState({servicableThisPostCode: false});
                }

            });


        } else if (!GeneralUtils.isNullOrEmpty(postCodeTemp) && value.postCode != undefined && !GeneralUtils.isNullOrEmpty(value)) {
            this.setState({postCode: postCodeTemp, postCodeTemp: postCodeTemp});
            this.setState({servicableThisPostCode: false});
            this.addressService.isServicableThisPostCode(localStorage.getItem("merchantBranchId"), postCodeTemp).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status) && GeneralUtils.isNullOrEmpty(response.message)) {
                    this.setDeliveryAddressDetailToLocalStorage(value);
                    this.setState({servicableThisPostCode: response});

                } else {
                    this.setState({servicableThisPostCode: false});
                }
            });
        } else {
            this.setState({servicableThisPostCode: false});
            this.setState({postCode: value, postCodeTemp: value});
        }


    }

    async getUserCurrentAddress() {
        let postCode = null;
        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("appMode")) && localStorage.getItem("appMode") == "member") {
            const response = (await this.memberUserAddressService.findAll());
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                response.forEach(itemSub => {
                    if (itemSub.defaultAddress) {
                        postCode = itemSub.postCode;
                    }
                });
            }
        }

        if (!GeneralUtils.isNullOrEmpty(postCode) && this.state.orderType == "Delivery") {
            this.addressService.isServicableThisPostCode(localStorage.getItem("merchantBranchId"), postCode).then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status) && GeneralUtils.isNullOrEmpty(response.message)) {
                    localStorage.setItem("postCode", postCode);
                    this.setState({servicableThisPostCode: response, postCode: postCode});

                } else {
                    this.setState({servicableThisPostCode: false, postCode: postCode});
                }


            });
        }
    }

    normalizeLookupAddressOptions(response) {
        if (!Array.isArray(response)) {
            return [];
        }
        return response
            .filter((el) => el != null && String(el.displayString != null ? el.displayString : "").trim() !== "")
            .map((el) => {
                const ds = String(el.displayString != null ? el.displayString : "").trim();
                return ds.toLowerCase() === "other" ? Object.assign({}, el, {displayString: "New"}) : el;
            });
    }

    resolvePostCodeForSearch() {
        const extractFromValue = (value) => {
            if (value == null) {
                return null;
            }
            if (typeof value === "string") {
                const trimmed = value.trim();
                return trimmed.length >= 6 ? trimmed : null;
            }
            if (typeof value === "object") {
                if (!GeneralUtils.isNullOrEmpty(value.postCode)) {
                    const pc = String(value.postCode).trim();
                    if (pc.length >= 6) {
                        return pc;
                    }
                }
                if (!GeneralUtils.isNullOrEmpty(value.displayString)) {
                    const display = String(value.displayString).trim();
                    const ukMatch = display.match(/\b([A-Z]{1,2}\d{1,2}[A-Z]?\s*\d[A-Z]{2})\b/i);
                    if (ukMatch && ukMatch[1]) {
                        return ukMatch[1].replace(/\s+/g, " ").toUpperCase();
                    }
                    if (display.length >= 6) {
                        return display;
                    }
                }
            }
            return null;
        };

        let postCode = extractFromValue(this.state.postCodeTemp);
        if (GeneralUtils.isNullOrEmpty(postCode)) {
            postCode = extractFromValue(this.state.postCode);
        }

        if (GeneralUtils.isNullOrEmpty(postCode) && this.dropDownAddress && this.dropDownAddress.focusInput) {
            const inputValue = String(this.dropDownAddress.focusInput.value || "").trim();
            if (inputValue.length >= 6) {
                postCode = inputValue;
            }
        }

        return postCode;
    }

    openAddressDropdownPanel() {
        if (!this.dropDownAddress) {
            return;
        }
        if (typeof this.dropDownAddress.show === "function") {
            this.dropDownAddress.show();
            return;
        }
        const keyEvent = {which: 99, preventDefault: () => {}, stopPropagation: () => {}};
        if (typeof this.dropDownAddress.onInputKeyDown === "function") {
            this.dropDownAddress.onInputKeyDown(keyEvent);
        }
    }

    searchAddress = (e) => {
        const postCode = this.resolvePostCodeForSearch();

        if (GeneralUtils.isNullOrEmpty(postCode)) {
            this.setState({filteredAddresses: [], servicableThisPostCode: false});
            toast.info("Enter a valid postcode (at least 6 characters)");
            return;
        }

        this.addressService.getAddresses(localStorage.getItem("merchantBranchId"), postCode).then(response => {
            const normalized = this.normalizeLookupAddressOptions(response);
            const postCodeForField = typeof this.state.postCode === "object" ? postCode : this.state.postCode;
            this.setState({
                filteredAddresses: normalized,
                postCodeTemp: postCode,
                postCode: postCodeForField || postCode
            }, () => {
                if (normalized.length > 0) {
                    window.setTimeout(() => this.openAddressDropdownPanel(), 0);
                } else {
                    this.addressService.isServicableThisPostCode(localStorage.getItem("merchantBranchId"), postCode).then(servicableResponse => {
                        if (!GeneralUtils.isNullOrEmpty(servicableResponse)
                            && GeneralUtils.isNullOrEmpty(servicableResponse.status)
                            && GeneralUtils.isNullOrEmpty(servicableResponse.message)) {
                            localStorage.setItem("postCode", postCode);
                            this.setState({servicableThisPostCode: servicableResponse});
                        } else {
                            this.setState({servicableThisPostCode: false});
                        }
                    });
                    toast.info("No Available Address");
                }
            });
        });
    }

    onChangeDeliveryType(value) {
        const previousOrderType = this.state.orderType;
        if (previousOrderType === value) {
            return;
        }

        this.setState({orderType: value});
        localStorage.setItem("orderType", value);

        if (value != undefined && !GeneralUtils.isNullOrEmpty(value) && value != "Table Order") {
            //localStorage.removeItem("tableBssId");
        }

        this.bumpMemberMenuContext();
        this.setState({
            crumbItems: [],
            shortcuts: [],
            subMenuChips: [],
            products: [],
            selectedCardId: null,
            offset: 0,
            selectedMenu: null,
            allDataLoaded: false
        }, () => {
            this.getWebMenuList(() => this.getProductsForHomeParent());
        });
    }

    showDeliveryType(type) {
        var showDeliveryType = false;
        for (var i = 0; i < this.state.deliveryTypesList.length; i++) {
            if (this.state.deliveryTypesList[i].name == type) {
                showDeliveryType = true;
            }
        }

        return showDeliveryType
    }

    renderDeliveryTypes() {
        let form = [];
        const isMobile = GeneralUtils.isMobile();
        const mobileDeliveryButtonStyle = isMobile ? {
            flex: "1 1 0",
            minWidth: 0,
            paddingLeft: "6px",
            paddingRight: "6px",
            fontSize: "12px",
            whiteSpace: "nowrap"
        } : undefined;
        form.push(<ButtonGroup className="delivery-type-group" style={{
            display: "flex",
            width: "100%",
            flexWrap: "nowrap",
            gap: isMobile ? "4px" : "6px"
        }}>
            {this.showDeliveryType("Delivery") && <ButtonReactStrap
                color="primary"
                outline
                className="delivery-type-btn"
                style={mobileDeliveryButtonStyle}
                onClick={(e) => {
                    //this.setState({servicableThisPostCode: false, postCode: null, postCodeTemp: null});
                    this.onChangeDeliveryType("Delivery")
                }}
                active={this.state.orderType === "Delivery"}
            >
                <span style={{display: "inline-flex", alignItems: "center", gap: "6px"}}>
                    <i className="material-icons delivery-type-icon" aria-hidden="true">two_wheeler</i>
                    <span>Delivery</span>
                </span>
            </ButtonReactStrap>}
            {this.showDeliveryType("Collection") && <ButtonReactStrap
                color="primary"
                outline
                className="delivery-type-btn"
                style={mobileDeliveryButtonStyle}
                onClick={(e) => {
                    //this.setState({servicableThisPostCode: false, postCode: null, postCodeTemp: null});
                    this.onChangeDeliveryType("Collection")
                }}
                active={this.state.orderType === "Collection"}
            >
                <span style={{display: "inline-flex", alignItems: "center", gap: "6px"}}>
                    <i className="material-icons delivery-type-icon" aria-hidden="true">storefront</i>
                    <span>Collection</span>
                </span>
            </ButtonReactStrap>}
            {this.showDeliveryType("Table Order") && <ButtonReactStrap
                color="primary"
                outline
                className="delivery-type-btn"
                style={mobileDeliveryButtonStyle}
                onClick={(e) => {
                    //this.setState({servicableThisPostCode: false, postCode: null, postCodeTemp: null});
                    this.onChangeDeliveryType("Table Order")
                }}
                active={this.state.orderType === "Table Order"}
            >
                <span style={{display: "inline-flex", alignItems: "center", gap: "6px"}}>
                    <i className="material-icons delivery-type-icon" aria-hidden="true">restaurant_menu</i>
                    <span>Table Order</span>
                </span>
            </ButtonReactStrap>}


        </ButtonGroup>);

        return form;
    }

    renderMenu = () => {
        return (<div style={{position: "relative", top: "-100px"}}>
            <ModalConfirm header='Warning' ok='Ok'
                          onCancelClick={() => this.setState({displayConfirmDialog: false})}
                          onOkClick={() => this.ageRestricted(this.state.item)}
                          show={this.state.displayConfirmDialog}
                          message={this.state.noticeResponse}/>

            <Row>

                {this.state.showItems &&
                    <Col md={8}>
                        {this.renderStoreInfoAndSearchText()}
                        {this.renderItems()}
                    </Col>

                }

                {(GeneralUtils.hasWebOrderLicense() || GeneralUtils.hasTableOrderLicense()) &&
                    <Col md={4}>
                        {this.renderCheckOut()}
                    </Col>}
            </Row>
            <Dialog visible={this.state.displayDialog}
                    className={this.getItemDetailsDialogClassName()}
                    position={this.getItemDetailsDialogPosition()}
                    baseZIndex={1000000}
                    blockScroll={true}
                    focusOnShow={false}
                    closeOnEscape={true}
                    closable={true}
                    onHide={() => this.setState({displayDialog: false})}
                    style={this.getItemDetailsDialogStyle()}>

                <ItemDetailsCheckOut ref={(elem) => this.itemsDetail = elem}
                                     dialogVisible={this.state.displayDialog}
                                     template3UI={this.isTemplate3()}
                                     accentColor={this.getMenuBorderColor()}
                                     onHide={() => this.closeDisplayDialog}
                                     addSetMenuItem={this.addSetMenuItem}
                                     addProduct={this.addProductToCart}
                                     closeDisplayDialog={this.closeDisplayDialog}/>

            </Dialog>
            {(GeneralUtils.hasWebOrderLicense() || GeneralUtils.hasTableOrderLicense()) && this.state.showItems == true && !this.state.displayDialog &&
                <AppFooterMemberMobile ref={(elem) => this.refAppFooterMember = elem}
                                       viewcart={this.viewcart}></AppFooterMemberMobile>
            }
            <MemberCookieConsentBanner/>

        </div>);
    }

    render() {
        let branchName = this.state.branchName;
        if (!GeneralUtils.isNullOrEmpty(branchName)) {
            return this.renderMenu()
        } else {
            return (<MarketPlace></MarketPlace>);
        }

    }

    viewcart = () => {
        this.setState({showItems: false}, () => {
            this.pushMemberMenuHistoryState();
        });
    }
    hidecart = () => {
        this.setState({showItems: true});

    }

    renderCheckOut() {
        let isMobile = !GeneralUtils.isMobile() || this.state.showItems == false;
        return (
            <div style={{
                zIndex: 10,
                position: "sticky",
                top: "46px",
                marginTop: "-72px",
                display: (isMobile) ? 'block' : 'none',
                right: GeneralUtils.isMobile() ? "0" : "-40px",
                overflow: "visible"
            }}>
                <OrderCheckOut ref={(elem) => this.refOrderCheckout = elem}
                               getBasketInfo={this.getBasketInfo}
                               refreshBasket={this.getBasketInfo}
                               checkDeliveryPostCodeIsValid={this.checkDeliveryPostCodeIsValid}
                               hidecart={this.hidecart}
                               openItemDetails={this.openItemDetails}
                               initialYourOrderOpen={true}></OrderCheckOut>
            </div>

        )

    }

    checkDeliveryPostCodeIsValid = () => {
        if (this.state.orderType == "Delivery" && this.showDeliveryType("Delivery")) {
            if (GeneralUtils.isNullOrEmpty(this.state.postCode)) {
                return "Select a postCode";
            }

            if (this.state.servicableThisPostCode == false) {
                return "We’re sorry, but the restaurant does not currently deliver to this address. Please choose to order via collection or from another restaurant.";
            }

        }

    }

    renderLegacyCardImage(item) {
        let style = {
            objectFit: 'contain',
            maxHeight: '80px',
            maxWidth: '80px',
            height: '80px',
            width: '80px',
            marginTop: '15px',
            marginBottom: '5px',
            borderRadius: "5px"
        };

        return (
            <div className="image-container member-menu-card-thumb">
                <img
                    style={style}
                    onError={(e) => e.target.src = "assets/layout/images/white.png"}
                    src={!GeneralUtils.isNullOrEmpty(this.resolveProductImagePath(item)) ? this.getProductImageSrc(item) : "assets/layout/images/white.png"}
                    alt={item.name}/>
            </div>
        );
    }

    renderLegacyCard() {
        const isSubMenu = this.state.crumbItems.length > 0;
        const isParentMenu = !isSubMenu;
        let height = 13;

        if (GeneralUtils.isMobile()) {
            height = 14;
        }
        let form = [];
        if (this.state.shortcuts != undefined && !GeneralUtils.isNullOrEmpty(this.state.shortcuts) && this.state.shortcuts.length > 0) {
            this.state.shortcuts.forEach((itemSub, shortcutIndex) => {
                const itemId = this.getMenuId(itemSub);
                const hasImage = !GeneralUtils.isNullOrEmpty(this.resolveProductImagePath(itemSub));
                const cardWrapClassName = `member-menu-card-wrap${isParentMenu ? " member-menu-card-wrap--parent" : ""}`;
                if (itemSub.lastShortcuts == false) {
                    form.push(
                        <div key={`sc-${itemId}-${shortcutIndex}-ls0`} className={cardWrapClassName} style={{
                            paddingTop: isSubMenu ? "6px" : "0",
                            paddingLeft: GeneralUtils.isMobile() && !isSubMenu ? "0" : (isSubMenu ? "2px" : "0"),
                            paddingRight: GeneralUtils.isMobile() && !isSubMenu ? "0" : (isSubMenu ? "2px" : "0"),
                            fontSize: isSubMenu ? "14px" : "30px",
                            textAlign: "center",
                            width: GeneralUtils.isMobile() ? "100%" : "auto",
                            boxSizing: "border-box",
                            maxWidth: "100%",
                            "--member-accent": this.getBackGroundColor()
                        }} onClick={() => this.refreshItems(itemSub)} id={itemId}
                        >
                            <Card hoverable header={hasImage ? this.renderLegacyCardImage(itemSub) : null}
                                  title={isSubMenu ? (
                                      <div style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "100%",
                                          height: "100%"
                                      }}>
                                          <div style={{
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              width: "100%",
                                              textAlign: "center",
                                              overflow: "hidden",
                                              wordBreak: "break-word",
                                              overflowWrap: "anywhere",
                                              padding: "0 6px",
                                              lineHeight: "1.1",
                                              fontSize: GeneralUtils.isMobile() ? "12px" : "14px"
                                          }}>
                                              {itemSub.name}
                                          </div>
                                      </div>
                                  ) : itemSub.name}
                                  subTitle={null}
                                  style={{
                                      width: GeneralUtils.isMobile() ? (isSubMenu ? "calc(100% - 2px)" : "100%") : (isSubMenu ? "150px" : "100%"),
                                      height: isSubMenu ? (GeneralUtils.isMobile() ? "50px" : "58px") : height + 'em',
                                      textAlign: "center"
                                  }}>
                            </Card>
                        </div>
                    );
                } else {
                    form.push(
                        <div key={`sc-${itemId}-${shortcutIndex}-ls1`} className={cardWrapClassName} style={{
                            paddingLeft: GeneralUtils.isMobile() && !isSubMenu ? "0" : (isSubMenu ? "2px" : "0"),
                            paddingRight: GeneralUtils.isMobile() && !isSubMenu ? "0" : (isSubMenu ? "2px" : "0"),
                            paddingTop: isSubMenu ? "6px" : "0",
                            paddingBottom: isSubMenu ? "6px" : "0",
                            fontSize: isSubMenu ? "14px" : "30px",
                            textAlign: "center",
                            width: GeneralUtils.isMobile() ? "100%" : "auto",
                            boxSizing: "border-box",
                            maxWidth: "100%",
                            "--member-accent": this.getBackGroundColor()
                        }} onClick={() => this.refreshItems(itemSub)} id={itemId}
                        >
                            <Card className={"check"} hoverable
                                  title={isSubMenu ? (
                                      <div style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          width: "100%"
                                      }}>
                                          <div style={{
                                              display: "-webkit-box",
                                              WebkitLineClamp: 2,
                                              WebkitBoxOrient: "vertical",
                                              width: "100%",
                                              textAlign: "center",
                                              overflow: "hidden",
                                              wordBreak: "break-word",
                                              overflowWrap: "anywhere",
                                              padding: "0 6px",
                                              lineHeight: "1.1",
                                              fontSize: GeneralUtils.isMobile() ? "12px" : "14px"
                                          }}>
                                              {itemSub.name}
                                          </div>
                                      </div>
                                  ) : itemSub.name}
                                  subTitle={null}
                                  style={{
                                      width: GeneralUtils.isMobile() ? (isSubMenu ? "calc(100% - 2px)" : "100%") : (isSubMenu ? "150px" : "100%"),
                                      height: isSubMenu ? (GeneralUtils.isMobile() ? "50px" : "58px") : '6em',
                                      textAlign: "center"
                                  }}>
                            </Card>
                        </div>
                    );
                }
            });
        }

        return form;
    }

    renderLegacyCards() {
        const isSubMenu = this.state.crumbItems.length > 0;
        const navKey = this.getMemberMenuFrameKey(false);
        if (isSubMenu) {
            return null;
        }
        if (GeneralUtils.isMobile()) {
            return (
                <div key={`sc-m-${navKey}`} style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "10px",
                    width: "100%",
                    maxWidth: "100%",
                    marginBottom: "10px",
                    padding: "8px 12px",
                    boxSizing: "border-box",
                    justifyItems: "stretch",
                    alignItems: "stretch"
                }}>
                    {this.renderLegacyCard()}
                </div>
            );
        }
        return (
            <div key={`sc-r-${navKey}`} style={{
                display: "grid",
                gridAutoFlow: "row",
                marginTop: "-48px",
                width: "100%",
                maxWidth: "1100px",
                marginLeft: "auto",
                marginRight: "auto",
                gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
                gap: "14px",
                padding: "0 10px",
                boxSizing: "border-box"
            }}>
                {this.renderLegacyCard()}
            </div>
        );
    }

    getCategoryImageSrc(item) {
        const imageSrc = this.getProductImageSrc(item);
        if (!GeneralUtils.isNullOrEmpty(imageSrc)) {
            return imageSrc;
        }
        return "assets/layout/images/white.png";
    }

    renderParentHeroCard(itemSub, shortcutIndex) {
        const itemId = this.getMenuId(itemSub);
        const hasImage = !GeneralUtils.isNullOrEmpty(this.resolveProductImagePath(itemSub));
        const accent = this.getMenuBorderColor();

        return (
            <div
                key={`sc-${itemId}-${shortcutIndex}-parent`}
                className="member-menu-card-wrap member-menu-card-wrap--parent"
                style={{"--member-accent": accent}}
                onClick={() => this.refreshItems(itemSub)}
                id={itemId}
            >
                <div className={`member-menu-hero-card${hasImage ? "" : " member-menu-hero-card--no-image"}`}>
                    {hasImage ? (
                        <div className="member-menu-hero-card__media">
                            <img
                                src={this.getCategoryImageSrc(itemSub)}
                                alt={itemSub.name}
                                onError={(e) => {
                                    e.target.style.display = "none";
                                    const media = e.target.parentElement;
                                    if (media) {
                                        media.classList.add("member-menu-hero-card__media--broken");
                                        const gradient = media.querySelector(".member-menu-hero-card__gradient");
                                        if (gradient) {
                                            gradient.style.display = "none";
                                        }
                                    }
                                    const card = e.target.closest(".member-menu-hero-card");
                                    if (card) {
                                        card.classList.add("member-menu-hero-card--no-image");
                                    }
                                }}
                            />
                            <div className="member-menu-hero-card__gradient"/>
                        </div>
                    ) : (
                        <div className="member-menu-hero-card__placeholder"/>
                    )}
                    <div className="member-menu-hero-card__title">{itemSub.name}</div>
                </div>
            </div>
        );
    }

    renderSubCategoryChip(itemSub, shortcutIndex) {
        const itemId = this.getMenuId(itemSub);
        const hasImage = !GeneralUtils.isNullOrEmpty(this.resolveProductImagePath(itemSub));
        const isSelected = this.isMenuItemSelected(itemId);
        const accent = this.getMenuBorderColor();

        return (
            <button
                key={`sc-${itemId}-${shortcutIndex}-chip`}
                type="button"
                className={`member-submenu-tab${isSelected ? " member-submenu-tab--selected" : ""}${hasImage ? " member-submenu-tab--image" : ""}`}
                style={{"--member-accent": accent}}
                onClick={() => this.refreshItems(itemSub)}
                id={itemId}
                aria-current={isSelected ? "true" : undefined}
                aria-pressed={isSelected}
            >
                {hasImage && (
                    <span className="member-submenu-tab__thumb">
                        <img
                            src={this.getCategoryImageSrc(itemSub)}
                            alt=""
                            onError={(e) => {
                                e.target.parentElement.style.display = "none";
                            }}
                        />
                    </span>
                )}
                <span className="member-submenu-tab__label" title={itemSub.name}>{itemSub.name}</span>
            </button>
        );
    }

    renderTemplate3CategoryHeader(hideActiveTrail = false) {
        const crumbItems = this.state.crumbItems;
        if (GeneralUtils.isNullOrEmpty(crumbItems) || crumbItems.length === 0) {
            return null;
        }

        const rootCrumb = crumbItems[0];
        const headerTitle = rootCrumb ? rootCrumb.label : "";
        const activeCrumb = crumbItems.length > 1 ? crumbItems[crumbItems.length - 1] : null;
        const activeTitle = activeCrumb ? activeCrumb.label : "";
        const isTopLevel = crumbItems.length === 1;
        const backLabel = isTopLevel ? "Ana menüye dön" : "Geri";
        const showActiveTrail = !hideActiveTrail && activeTitle;

        return (
            <div className="member-submenu-nav__header">
                <button
                    type="button"
                    className="member-submenu-nav__back"
                    onClick={() => this.handleMemberMenuBack()}
                    aria-label={backLabel}
                >
                    <span className="member-submenu-nav__back-icon" aria-hidden="true">←</span>
                </button>
                <div className="member-submenu-nav__title-wrap">
                    <nav className="member-submenu-nav__trail" aria-label="Menü konumu">
                        <span className="member-submenu-nav__title" title={headerTitle}>{headerTitle}</span>
                        {showActiveTrail && (
                            <>
                                <span className="member-submenu-nav__sep" aria-hidden="true">›</span>
                                <span className="member-submenu-nav__active" title={activeTitle}>{activeTitle}</span>
                            </>
                        )}
                    </nav>
                </div>
            </div>
        );
    }

    renderMemberSubMenuNav() {
        if (this.state.crumbItems.length === 0 || this.state.searchText.length > 3) {
            return null;
        }

        const navKey = this.getMemberMenuFrameKey(false);
        const subMenuChips = this.getTemplate3SubMenuChips();
        const hasChips = subMenuChips.length > 0;
        const showChipSkeleton = this.state.loading && !hasChips;
        const showChipRow = hasChips || showChipSkeleton;

        return (
            <div
                key={`subnav-${navKey}`}
                className="member-submenu-nav member-submenu-nav--sticky"
                style={{"--member-accent": this.getMenuBorderColor()}}
            >
                <div className="member-submenu-nav__panel">
                    {this.renderTemplate3CategoryHeader(hasChips)}
                    {showChipRow && (
                        <div className="member-submenu-nav__chips">
                            <div className="member-menu-chips-scroll">
                                {showChipSkeleton
                                    ? this.renderTemplate3ChipSkeleton(this.isMemberMenuNarrowViewport() ? 4 : 6)
                                    : subMenuChips.map((itemSub, shortcutIndex) => this.renderSubCategoryChip(itemSub, shortcutIndex))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    refreshCrumbItems(itemSub) {
        const itemId = this.getMenuId(itemSub);
        let crumbItems = [...this.state.crumbItems];
        const objWithIdIndex = crumbItems.findIndex((obj) => obj.id === itemId);
        if (objWithIdIndex > -1) {
            crumbItems.length = objWithIdIndex + 1;
        }
        this.scrollMemberMenuToTop();
        this.setState({
            crumbItems: crumbItems,
            selectedCardId: itemId,
            offset: 0,
            allDataLoaded: false,
            loading: true,
            products: [],
            subMenuChips: crumbItems.length <= 1 ? [] : this.state.subMenuChips
        }, () => {
            this.scrollMemberMenuToTop();
        });
        this.getItemsFromDb(itemSub, itemId);
    }

    async getItemsFromDb(itemSub, itemIdParam = null) {
        const branchId = localStorage.getItem("merchantBranchId");
        const limit = this.state.limit;
        const itemId = itemIdParam || this.getMenuId(itemSub);

        if (!GeneralUtils.isNullOrEmpty(localStorage.getItem("appMode")) && localStorage.getItem("appMode") === "member") {
            if (itemSub != null && !GeneralUtils.isNullOrEmpty(itemId)) {
                this.bumpMemberMenuContext();
                const epochAtRequest = this._menuSyncEpoch;

                this.setState({
                    loading: true,
                    selectedMenu: itemId,
                    products: [],
                    shortcuts: [],
                    offset: 0,
                    allDataLoaded: false
                });

                // Shortcuts (alt menüler) için pagination
                if (itemSub.lastShortcuts === false) {
                    const shortcutResponse = await this.webMenuMemberService.getActiveSubWebMenuShortcutsForMemberByParentId(
                        branchId,
                        itemId,
                        0,
                        limit
                    );

                    if (epochAtRequest !== this._menuSyncEpoch) {
                        return;
                    }
                    if ((this.state.selectedMenu || null) != itemId) {
                        return;
                    }

                    if (!GeneralUtils.isNullOrEmpty(shortcutResponse) && GeneralUtils.isNullOrEmpty(shortcutResponse.status)) {
                        this.setState({ shortcuts: shortcutResponse });
                    } else {
                        this.setState({ shortcuts: [] });
                    }
                }

                // Products için pagination
                const response = await this.webMenuMemberService.getWebMenuItemsByParentId(
                    branchId,
                    itemId,
                    0,
                    limit
                );

                if (epochAtRequest !== this._menuSyncEpoch) {
                    return;
                }
                if ((this.state.selectedMenu || null) != itemId) {
                    return;
                }

                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.status)) {
                    this.setState({
                        products: response,
                        offset: limit,
                        loading: false
                    });
                    this.getBasketInfo();
                } else {
                    this.setState({
                        products: [],
                        loading: false,
                        allDataLoaded: true
                    });
                }
            }
        }
    }



    clearSubMenuChipSelection() {
        const crumbItems = this.state.crumbItems;
        if (!crumbItems || crumbItems.length <= 1) {
            return;
        }
        this.navigateToTemplate3RootCategory(crumbItems[0]);
    }

    refreshItems(itemSub) {
        const itemId = this.getMenuId(itemSub);
        if (GeneralUtils.isNullOrEmpty(itemId)) {
            return;
        }

        if (this.isMenuItemSelected(itemId) && this.state.crumbItems.length > 1) {
            this.clearSubMenuChipSelection();
            return;
        }

        this.scrollMemberMenuToTop();

        let crumbItems = [...this.state.crumbItems];
        const lastCrumb = crumbItems[crumbItems.length - 1];

        if (lastCrumb && String(lastCrumb.id) === String(itemId)) {
            this.setState({
                selectedCardId: itemId,
                loading: true,
                products: [],
                offset: 0,
                allDataLoaded: false
            }, () => {
                this.scrollMemberMenuToTop();
            });
            this.getItemsFromDb(itemSub, itemId);
            return;
        }

        if (this.isTemplate3()) {
            crumbItems.push({
                label: itemSub.name, id: itemId, lastShortcuts: itemSub.lastShortcuts, command: (e) => {
                    this.refreshCrumbItems(itemSub)
                }
            });
        } else if (crumbItems.length > 0 && crumbItems[crumbItems.length - 1].lastShortcuts) {
            crumbItems = crumbItems.slice(0, crumbItems.length - 1);
            crumbItems.push({
                label: itemSub.name, id: itemId, lastShortcuts: itemSub.lastShortcuts, command: (e) => {
                    this.refreshCrumbItems(itemSub)
                }
            })
        } else {
            crumbItems.push({
                label: itemSub.name, id: itemId, lastShortcuts: itemSub.lastShortcuts, command: (e) => {
                    this.refreshCrumbItems(itemSub)
                }
            })
        }

        const inSubMenu = this.state.crumbItems.length > 0;
        const preserveChips = inSubMenu
            && this.state.shortcuts != undefined
            && !GeneralUtils.isNullOrEmpty(this.state.shortcuts)
            && this.state.shortcuts.length > 0
            ? [...this.state.shortcuts]
            : (inSubMenu ? (this.state.subMenuChips || []) : []);

        this.setState({
            crumbItems: crumbItems,
            selectedCardId: itemId,
            subMenuChips: preserveChips,
            loading: true,
            products: [],
            offset: 0,
            allDataLoaded: false
        }, () => {
            this.scrollMemberMenuToTop();
        });
        this.getItemsFromDb(itemSub, itemId);
        this.pushMemberMenuHistoryState();
    }

    getMenuBorderColor() {
        if (!GeneralUtils.isNullOrEmpty(this.state.addressInfo.menuBorderColor)) {
            const color = String(this.state.addressInfo.menuBorderColor).trim();
            return color.startsWith('#') ? color : `#${color}`;
        }
        return '#00bcd4';
    }

    getBackGroundColor() {
        return this.getMenuBorderColor();
    }

    getMenuId(item) {
        if (GeneralUtils.isNullOrEmpty(item)) {
            return null;
        }
        return !GeneralUtils.isNullOrEmpty(item.id) ? item.id : item.webMenuBssId;
    }

    isMenuItemSelected(itemId) {
        if (GeneralUtils.isNullOrEmpty(itemId)) {
            return false;
        }
        const selected = this.state.selectedCardId;
        if (selected != null && String(selected) === String(itemId)) {
            return true;
        }
        const crumbs = this.state.crumbItems;
        if (crumbs.length > 1) {
            const active = crumbs[crumbs.length - 1];
            return active && String(active.id) === String(itemId);
        }
        return false;
    }

    getTemplate3SubMenuChips() {
        const shortcuts = this.state.shortcuts;
        if (shortcuts != undefined && !GeneralUtils.isNullOrEmpty(shortcuts) && shortcuts.length > 0) {
            return shortcuts;
        }
        const subMenuChips = this.state.subMenuChips;
        if (subMenuChips != undefined && !GeneralUtils.isNullOrEmpty(subMenuChips) && subMenuChips.length > 0) {
            return subMenuChips;
        }
        return [];
    }

    renderCard() {
        if (!this.isTemplate3()) {
            return this.renderLegacyCard();
        }

        const isSubMenu = this.state.crumbItems.length > 0;
        let form = [];

        if (this.state.shortcuts != undefined && !GeneralUtils.isNullOrEmpty(this.state.shortcuts) && this.state.shortcuts.length > 0) {
            this.state.shortcuts.forEach((itemSub, shortcutIndex) => {
                if (isSubMenu) {
                    form.push(this.renderSubCategoryChip(itemSub, shortcutIndex));
                } else {
                    form.push(this.renderParentHeroCard(itemSub, shortcutIndex));
                }
            });
        }

        return form;
    }

    renderCards() {
        if (!this.isTemplate3()) {
            return this.renderLegacyCards();
        }

        const isSubMenu = this.state.crumbItems.length > 0;
        const navKey = this.getMemberMenuFrameKey(false);

        if (isSubMenu) {
            return null;
        }

        return (
            <div
                key={`sc-grid-${navKey}`}
                className={`member-menu-grid--parent${GeneralUtils.isMobile() ? " member-menu-grid--parent-mobile" : ""}`}
                style={{"--member-accent": this.getMenuBorderColor()}}
            >
                {this.renderCard()}
            </div>
        );
    }

    renderItems() {

        let form = [];
        const memberSubNav = this.renderMemberSubMenuNav();
        if (memberSubNav) {
            form.push(memberSubNav);
        }

        if (this.state.searchText.length <= 3) {
            if (this.isTemplate3()) {
                if (!memberSubNav) {
                    form.push(this.renderCards());
                }
            } else if (!memberSubNav) {
                form.push(this.renderCards());
            }
        }

        let listStyle = {
            height: 'auto',
            gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
            display: "grid",
            gap: "0px 20px"
        };
        if (this.isMemberMenuNarrowViewport()) {
            listStyle = {
                height: 'auto',
                display: "grid",
                gridTemplateColumns: "minmax(0, 1fr)",
                gap: "10px",
                width: "100%"
            };
        }

        if (this.isTemplate3()) {
            listStyle = this.getTemplate3ListStyle();
        }

        if (this.state.addressInfo.menuDisplayTemplate == "Template2") {
            listStyle = {
                height: "auto",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(148px, 1fr))",
                gap: "12px 14px",
                width: "100%"
            };
            if (this.isMemberMenuNarrowViewport()) {
                listStyle = {
                    height: "auto",
                    display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                    gap: "10px 12px",
                    width: "100%"
                };
            }
        }


        const showProductInitialSkeleton = this.usesProductCardSkeleton()
            && this.state.loading
            && GeneralUtils.isNullOrEmpty(this.state.products)
            && !this.isParentMenuLevel();
        const showProductLoadMoreSkeleton = this.usesProductCardSkeleton()
            && this.state.loading
            && !GeneralUtils.isNullOrEmpty(this.state.products);

        form.push(
            <div
                key={`ol-wrap-${this.getMemberMenuFrameKey(true)}`}
                className={`orderlist-demo${this.isTemplate3() ? " orderlist-demo--template3" : ""}${memberSubNav ? " orderlist-demo--template3-subnav" : ""}`}
                style={this.isTemplate3() || memberSubNav || this.usesProductCardSkeleton()
                    ? {"--member-accent": this.getMenuBorderColor()}
                    : undefined}
            >
                <div className="card" style={{
                    position: "inherit",
                    border: "0px",
                    marginTop: GeneralUtils.isMobile() ? "8px" : "12px",
                    paddingLeft: GeneralUtils.isMobile() ? 0 : undefined,
                    paddingRight: GeneralUtils.isMobile() ? 0 : undefined
                }}>
                    {showProductInitialSkeleton ? (
                        this.renderProductSkeletonGrid(
                            listStyle,
                            this.isMemberMenuNarrowViewport() ? 4 : 6
                        )
                    ) : (
                        <>
                            <OrderList key={this.getMemberMenuFrameKey(true)}
                                       value={this.state.products}
                                       listStyle={listStyle}
                                       dataKey="id"
                                       itemTemplate={this.productItem}
                            ></OrderList>
                            {showProductLoadMoreSkeleton &&
                                this.renderProductSkeletonGrid(
                                    listStyle,
                                    this.isMemberMenuNarrowViewport() ? 1 : 2,
                                    true
                                )
                            }
                        </>
                    )}
                </div>
            </div>
        )


        return form;
    }

}